<button
  [class.focus]="focus()"
  class="min-w-[5.8rem] hover:bg-primary/5 hover:text-primary rounded-md w-full flex items-center gap-2 px-2 py-1.5 transition-all duration-200 cursor-pointer outline-none select-none font-medium text-[13px] text-base-content/70 group">
  <div class="flex items-center shrink-0">
    @if (icon(); as i) {
      <span
        class="text-base transition-colors duration-200"
        [ngClass]="[
          i.startsWith('icon-[') ? i : 'icon-[' + i.replace(':', '--') + ']',
          i.includes('delete') || i.includes('trash')
            ? 'text-error/40 group-hover:text-error'
            : 'text-base-content/30 group-hover:text-primary',
        ]"></span>
    }
  </div>
  <span class="flex-1 text-left">
    <ng-content />
  </span>
  @if (active()) {
    <span class="icon-[mdi--check] text-sm text-primary"></span>
  }
</button>
